shadow$provide[262] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Retext:{enumerable:true, get:function() {
  return Retext;
}}});
var require$_DOT__DOT__SLASH_operator_SLASH_resample_DOT_js = require("../operator/resample.js");
class Retext extends require$_DOT__DOT__SLASH_operator_SLASH_resample_DOT_js.Resample {
  static initClass() {
    this.traits = ["node", "bind", "operator", "resample", "sampler:x", "sampler:y", "sampler:z", "sampler:w", "include", "text",];
  }
  init() {
    return this.sourceSpec = [{to:"operator.source", trait:"text"}];
  }
  textShader(shader) {
    return this.bind.source.textShader(shader);
  }
  textIsSDF() {
    return (this.bind.source != null ? this.bind.source.props.sdf : undefined) > 0;
  }
  textHeight() {
    return this.bind.source != null ? this.bind.source.props.detail : undefined;
  }
}
Retext.initClass();

};